var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PaginationWrapper',{attrs:{"page":_vm.page,"totalCount":_vm.totalCount,"export":""},on:{"onPageChange":_vm.handlePageChange,"exportTable":_vm.exportList}},[_c('AlarmsSearchOptions',{attrs:{"slot":"search-options","modules":true},on:{"onSearch":_vm.handleSearch},slot:"search-options"}),_c('AlarmsTable',{attrs:{"slot":"table"},slot:"table"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }